export default __webpack_public_path__ + "static/media/72.404315a9.jpeg";